
import useRoomBaseServer from '../room/roombase.server';
import PrivacyAgreementApi from '../../request/interacts/privacy-agreement';
import BaseServer from '../common/base.server';

class PrivacyAgreementServer extends BaseServer {
  constructor(opt = {}) {
    super();
    const watchInitData = useRoomBaseServer().state.watchInitData;
    this._roomId = watchInitData.interact?.room_id;
    this._webinarId = watchInitData.webinar?.id;
  }
  /**
    * 取隐私协议信息
    * @param {*} module  所属模块：0 观看协议 1 活动观看限制 2 抽奖 3 互动有礼 4 专题观看限制
    * @param {*} sourceId 模块记录 id, 如：抽奖 id';
    * @returns
    */
  getPrivacyAgreement(module, sourceId) {
    const params = {
      module: module,
      source_id: sourceId
    }
    if ([1, 2, 3, 5].includes(module)) {
      params.webinar_id = this._webinarId;
    }
    return PrivacyAgreementApi.getPrivacyAgreement(params);
  }
  /**
   * 保存隐私协议
   * @param {Object} params 隐私协议数据
   *  {
   *   webinar_id: 可选
   *   module:
   *   source_id:
   *   statement_status:
   *   statement_content
   *   statement_info
   *  }
   * @returns
   */
  savePrivacyAgreement(params = {}) {
    if ([1, 2, 3].includes(params.module) && !params.webinar_id) {
      params.webinar_id = this._webinarId;
    }
    return PrivacyAgreementApi.savePrivacyAgreement(params);
  }
};

export default function usePrivacyAgreementServer(opt) {
  if (!PrivacyAgreementServer.instance) {
    PrivacyAgreementServer.instance = new PrivacyAgreementServer(opt);
  }
  return PrivacyAgreementServer.instance;
}
